export default function is_probably_googlebot(){

        const ua = navigator.userAgent;
        return ( /googlebot/i.test( ua ) || /Google-Structured-Data-Testing-Tool/i.test( ua ) );
    
}